<strong>
  @if (!showError) {
    <ng-content select="kb-hint"></ng-content>
  } @else {
    <ng-content select="kb-error"></ng-content>
  }
</strong>
